module.exports = __webpack_public_path__ + "static/media/facilities_1.6d335d16.png";